// Base
const colorDangerBase = '#B20000';

// Text
export const textDangerBase = colorDangerBase;
export const placeholderTextDefault = '#595959';

// Border
export const borderDangerBase = colorDangerBase;
